
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vueScrollto from 'vue-scrollto';
import axios from 'axios';

// Create a new Vue app
const app = createApp(App);

// Set Axios as a global property
app.config.globalProperties.$axios = axios;

// Use plugins
app.use(vueScrollto);
app.use(router);
app.use(store);

// Global directive for click outside
app.directive('click-outside', {
  beforeMount(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.component?.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be.`;
      if (compName) {
        warn += ` Found in component '${compName}'`;
      }
      console.warn(warn);
    }

    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e); // Call the provided function
      }
    };

    // Add Event Listeners
    document.addEventListener('click', handler);
    el.__vueClickOutside__ = handler;
  },
  unmounted(el) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  },
});

// Global filter for formatting numbers
app.config.globalProperties.$filters = {
  formatNumber(value) {
    return numeral(value).format('0,0'); // Displaying other groupings/separators is possible, look at the docs
  },
};

// Define the global currency formatting method
app.config.globalProperties.$formatNumber = (value) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'decimal', // Use 'decimal' for plain numbers without currency
    minimumFractionDigits: 0, // No decimal places
    maximumFractionDigits: 0, // No decimal places
  }).format(value);
};

// Add the font change method as a global property
app.config.globalProperties.$changeFont = (fontOption) => {
  const fonts = {
    1: {
      primary: '"Poppins", sans-serif',
      secondary: '"Poppins", sans-serif',
      weight: 400,
    },
    2: {
      primary: '"Poppins", sans-serif',
      secondary: '"Poppins", sans-serif',
      weight: 500,
    },
    3: {
      primary: '"Poppins", sans-serif',
      secondary: '"Poppins", sans-serif',
      weight: 600,
    },
    // 3: {
    //   primary: '"adobe-garamond-pro", serif',
    //   secondary: 'parastoo", serif',
    // },
    // 4: {
    //   primary: '"parastoo", sans-serif',
    //   secondary: '"parastoo", sans-serif',
    // },
    // 5: {
    //   primary: '"freight-sans-pro", sans-serif',
    //   secondary: '"freight-sans-pro", sans-serif',
    // },
  };

  // Get the selected font pair
  const selectedFonts = fonts[fontOption];

  // Apply the fonts to the :root CSS variables
  if (selectedFonts) {
    document.documentElement.style.setProperty('--main-font', selectedFonts.primary);
    document.documentElement.style.setProperty('--main-font-regular', selectedFonts.secondary);
    document.documentElement.style.setProperty('--main-text-font', selectedFonts.primary);
    document.documentElement.style.setProperty('--main-font-weight', selectedFonts.weight);
  }
};

// Mount the app
app.mount('#app');